import Button from '@atlaskit/button/standard-button';
import AKFeedbackCollector from '@atlaskit/feedback-collector';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import { G300 } from '@atlaskit/theme/colors';
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useUserDetails } from '@atlassian/mpac-ui';
import { DOMUtils } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { openFeedbackCollectorEventFields, submitFeedbackCollectorEventFields } from './PartnerFeedback.events';
/*
 Customer feedback gets funneled into the customer feedback project.
 https://customerfeedback.atlassian.net/jira/servicedesk/projects/MPRV2/queues/custom/815

 Project name: Marketplace partner reports v2
 Slack link: https://atlassian.slack.com/archives/CFNR0H874/p1676314301025399?thread_ts=1676312670.945929&cid=CFNR0H874
 */
//
export const ENTRYPOINT_ID = '98f371a6-a496-46c6-ae65-e954e7e4e0d9';
const FeedbackPreamble = () => /*#__PURE__*/React.createElement("div", {
  style: {
    paddingBottom: '0.5em'
  },
  "data-testid": "feedback-collector-preamble"
}, /*#__PURE__*/React.createElement("p", null, "Your thoughts are valuable in helping improve the partner experience."));
const PartnerFeedback = props => {
  const {
    mpacBaseUrl,
    attributes
  } = props;
  const [isFeedbackCollectorOpen, setFeedbackCollectorOpen] = useState(false);
  const [isFlagOpen, setFlagOpen] = useState(false);
  const userDetails = useUserDetails();
  const fireAnalyticsEvent = useAnalyticsEvents();
  const additionalFields = [{
    id: 'customfield_10047',
    value: attributes
  }];
  const giveFeedback = () => {
    fireAnalyticsEvent(openFeedbackCollectorEventFields(attributes));
    DOMUtils.scrollToDocumentTop();
    setFeedbackCollectorOpen(true);
  };
  const onFeedbackClose = () => setFeedbackCollectorOpen(false);
  const displayFlag = () => {
    fireAnalyticsEvent(submitFeedbackCollectorEventFields(attributes));
    setFlagOpen(true);
  };
  const hideFlag = () => setFlagOpen(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    onClick: giveFeedback
  }, "Give feedback"), isFeedbackCollectorOpen && /*#__PURE__*/React.createElement(AKFeedbackCollector, {
    onClose: onFeedbackClose,
    onSubmit: displayFlag,
    customGatewayUrl: "".concat(mpacBaseUrl, "/gateway/api/"),
    name: userDetails === null || userDetails === void 0 ? void 0 : userDetails.name,
    atlassianAccountId: userDetails === null || userDetails === void 0 ? void 0 : userDetails.accountId,
    entrypointId: ENTRYPOINT_ID,
    feedbackTitleDetails: /*#__PURE__*/React.createElement(FeedbackPreamble, null),
    shouldGetEntitlementDetails: false,
    feedbackTitle: "Share feedback",
    cancelButtonLabel: "Cancel",
    submitButtonLabel: "Share Feedback",
    additionalFields: additionalFields
  }), /*#__PURE__*/React.createElement(FlagGroup, {
    onDismissed: hideFlag
  }, isFlagOpen && /*#__PURE__*/React.createElement(AutoDismissFlag, {
    icon: /*#__PURE__*/React.createElement(SuccessIcon, {
      primaryColor: "var(--ds-icon-success, ".concat(G300, ")"),
      label: "Success",
      size: "medium"
    }),
    title: "Thanks!",
    description: "Your valuable feedback helps us continually improve our products.",
    id: "partner-feedback-flag"
  })));
};
export default PartnerFeedback;